import React from 'react';
import Head from 'expo-router/head';
import { Asset } from 'expo-asset';
import useSceneActivity from './useSceneActivity.web';

const scene = Asset.fromModule(require('@/assets/images/landing-hero-pixel-robot.webp')).uri;
const sceneNarrow = Asset.fromModule(require('@/assets/images/landing-hero-pixel-robot-1000w.webp')).uri;
const srcSet = `${sceneNarrow} 1000w, ${scene} 1672w`;

// HTML img is the LCP candidate (srcset + fetchpriority). SVG overlays stay in
// the original 1672×941 coordinate system so ripples and leaves stay anchored.
const coverStyle = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'right center',
  imageRendering: 'pixelated',
  pointerEvents: 'none',
};

function LivingPixelScene() {
  const activityRef = useSceneActivity();
  return (
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden' }}>
      <Head>
        <link rel="preload" as="image" type="image/webp" href={scene} imageSrcSet={srcSet} imageSizes="100vw" fetchPriority="high" />
      </Head>
      <img src={scene} srcSet={srcSet} sizes="100vw" alt="" aria-hidden="true" fetchPriority="high" decoding="async" style={coverStyle} />
      <svg ref={activityRef} data-scene-active="false" data-pixel-scene="true" aria-hidden="true" focusable="false" viewBox="0 0 1672 941" preserveAspectRatio="xMaxYMid slice" style={{ position: 'absolute', width: '100%', height: '100%', overflow: 'hidden', pointerEvents: 'none' }}>
        <g shapeRendering="crispEdges">
          {Array.from({ length: 18 }, (_, i) => {
            const x = 340 + (i * 137) % 730;
            const y = 655 + (i * 37) % 140;
            return <rect key={i} data-pixel-ripple="true" x={x} y={y} width={12 + i % 5 * 7} height={2 + i % 2} fill={i % 3 ? '#b6f3ed' : '#fff1bf'} style={{ animationDelay: `${-i * .7}s`, animationDuration: `${3 + i % 4}s` }} />;
          })}
          {[0, 1, 2].map(i => (
            <g key={i} transform={`translate(${1280 + i * 65} ${80 + i * 38})`}>
              <path data-pixel-leaf="true" d="M0 0h8v4h4v8H4V8H0z" fill={i % 2 ? '#b2cf44' : '#69a438'} style={{ animationDelay: `${-i * 3.7}s`, animationDuration: `${14 + i * 2}s` }} />
            </g>
          ))}
        </g>
      </svg>
    </div>
  );
}

export default React.memo(LivingPixelScene);
